<template>
    <div>
        <Breadcrumbs main="Admin" submain="House" title="House" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div style="max-width: fit-content;"> 
                                <router-link to="/house/register">
                                    <button class="btn btn-primary" type="submit" style="display: flex; gap: 12px; align-items: center;">
                                        <i class="fa fa-light fa-plus"></i>
                                        <h7>Add New House</h7>
                                    </button>
                                </router-link> 
                            </div>
                        </div>
    
                        <div class="card-body">
                            <b-row class="d-flex justify-content-center align-items-center">
                                <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                    <b-input-group style="width: 340px;">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                        <feather type="filter"></feather>
                                        <h7>Filter</h7> 
                                    </div>

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="filterShow">
                                        <feather type="x"></feather>
                                        <h7>Clear All</h7>
                                    </div>
                                </b-col> 
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <div class="row mt-2" v-if="filterShow">
                                <div class="col-md-4"> 
                                    <div class="grid-container mt-sm-0">
                                        <div class="grid-item">
                                            <span>Shelter</span>
                                            <b-form-select v-model="shelter" :options="formattedShelters"></b-form-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4"> 
                                    <div class="grid-container mt-sm-0">
                                        <div class="grid-item">
                                            <span>House Type</span>
                                            <b-form-select v-model="house_condition" :options="formattedHouse"></b-form-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4"> 
                                    <div class="grid-container mt-sm-0">
                                        <div class="grid-item">
                                            <span>Health Condition</span>
                                            <b-form-select v-model="health_condition" :options="formattedHealth"></b-form-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue mt-4">
                                    <b-table :items="house_list" :fields="tablefields" :per-page="perPage" show-empty stacked="md">

                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(house)="row">
                                            <div v-if="row.item?.home?.doc_id && row.item.home.doc_id.length < 24">
                                                <div v-if="row.item" style="display: flex; flex-direction: column; min-width: 220px; background-color: #fcf0e8;">
                                                    <span>House Name: <span style="font-weight: 500;">{{ row.item.home.house_name }}</span></span>
                                                    <span>House Type: <span style="font-weight: 500;">{{ row.item.home.house_type }}</span></span>
                                                    <span>Distance: <span style="font-weight: 500;">{{ row.item.home.house_geo_location }}</span></span>
                                                    <span>Road Condition: <span style="font-weight: 500;">{{ row.item.home.road_condition }}</span></span>
                                                    <span>DOC ID: <span style="font-weight: 500;">{{ row.item.home.doc_id }}</span></span>
                                                    <span v-if="row.item.user1.total_member !== row.item.other_members.length + 2" class="badge badge-pill badge-danger" style="max-width: 200px;">Other Members Data Missing</span>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div v-if="row.item" style="display: flex; flex-direction: column; min-width: 220px;">
                                                    <span>House Name: <span style="font-weight: 500;">{{ row.item.home.house_name }}</span></span>
                                                    <span>House Type: <span style="font-weight: 500;">{{ row.item.home.house_type }}</span></span>
                                                    <span>Distance: <span style="font-weight: 500;">{{ row.item.home.house_geo_location }}</span></span>
                                                    <span>Road Condition: <span style="font-weight: 500;">{{ row.item.home.road_condition }}</span></span>
                                                    <span>DOC ID: <span style="font-weight: 500;">{{ row.item.home.doc_id }}</span></span>
                                                    <span v-if="row.item.user1.total_member !== row.item.other_members.length + 2" class="badge badge-pill badge-danger" style="max-width: 200px;">Other Members Data Missing</span>
                                                </div>
                                            </div>
                                        </template>

                                        <template #cell(address)="row">
                                            <div v-if="row.item" style="display: flex; flex-direction: column; width: 220px;">
                                                <span>Shelter: <span style="font-weight: 500;">{{ row.item.home.address_line }}</span></span>
                                                <span  class="mt-2">
                                                    <span v-if="row.item.home && row.item.home.volunteer_info">Volunteer Info: <span style="font-weight: 500; word-break: break-all;">{{ row.item.home.volunteer_info }}</span></span>
                                                    <span v-else>Volunteer Info: <span style="font-weight: 500; word-break: break-all;">Not Available</span></span>
                                                </span>
                                            </div>
                                        </template>

                                        <template #cell(family_representative)="row">
                                            <div v-if="row.item" style="display: flex; flex-direction: column; min-width: 220px;">
                                                <span>Name: <span style="font-weight: 500;">{{ row.item.user1.name }}</span></span>
                                                <span>Phone Number: <span style="font-weight: 500;">{{ row.item.user1.phone }}</span></span>
                                                <span>NID: <span style="font-weight: 500;">{{ row.item.user1.nid }}</span></span>
                                                <span>Gender: <span style="text-transform: capitalize; font-weight: 500;">{{ row.item.user1.gender }}</span></span>
                                                <span>Age: <span style="font-weight: 500;">{{ row.item.user1.age }}</span></span>
                                                <span>Health Condition: <span style="font-weight: 500; text-transform: capitalize;">{{ row.item.user1.health_condition }}</span></span>
                                            </div>
                                        </template>

                                        <template #cell(sub_representative)="row">
                                            <div v-if="row.item" style="display: flex; flex-direction: column; min-width: 220px;">
                                                <span>Name: <span style="font-weight: 500;">{{ row.item.user2.name }}</span></span>
                                                <span>Phone Number: <span style="font-weight: 500;">{{ row.item.user2.phone }}</span></span>
                                                <span>NID: <span style="font-weight: 500;">{{ row.item.user2.nid }}</span></span>
                                                <span>Gender: <span style="text-transform: capitalize; font-weight: 500;">{{ row.item.user2.gender }}</span></span>
                                                <span>Age: <span style="font-weight: 500;">{{ row.item.user2.age }}</span></span>
                                                <span>Health Condition: <span style="font-weight: 500; text-transform: capitalize;">{{ row.item.user2.health_condition }}</span></span>
                                            </div>
                                        </template>
    
                                        <template #cell(action)="data">
                                            <div @click="getDetail(data.item)">
                                                <feather type="eye" size="21px" style="color: #e4701e; cursor: pointer; padding: 20px;" v-b-tooltip.hover v-b-modal.modal-prevent-closing-edit title="View"></feather> 
                                            </div>
                                        </template>
                                    </b-table> 
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->

        <!-- House Detail View Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="dynamicModal" title="View House Detail" hide-footer size="xl" @hidden="destroyModalInstance">
            <div style="padding: 0px 4px;">
                <p style="font-size: larger; font-weight: 600;">Address (ঠিকানা)</p>

                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Shelter (আশ্রয়কেন্দ্র)</label> 
                            <select disabled class="form-control digits" v-model="house.home_address.address_shelter" style="height: 44px;">
                                <option selected disabled>Select a shelter</option>
                                <option v-for="(type, index) in shelter_list" :key="index" :value="type.id">{{ type.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Union (ইউনিয়ন)</label>
                            <select disabled class="form-control digits" v-model="house.home_address.address_union" style="height: 44px;">
                                <option selected disabled>Select a union</option>
                                <option v-for="(type, index) in union" :key="index" :value="type.id">{{ type.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Upazila (উপজেলা)</label>
                            <select disabled class="form-control digits" v-model="house.home_address.address_upozila" style="height: 44px;">
                                <option selected disabled>Select a upazila</option>
                                <option v-for="(type, index) in upozilas" :key="index" :value="type.id">{{ type.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>House Name (বাড়ীর নাম)</label>
                            <input disabled class="form-control" type="text" placeholder="Type House Name (বাড়ীর নাম)" v-model="house.home.house_name" style="height: 44px;">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>House Type (বাড়ীর কাঠামো)</label>
                            <select disabled class="form-control digits" v-model="house.home.house_type" style="height: 44px;">
                                <option selected disabled>Select a type</option>
                                <option v-for="(type, index) in house_types" :key="index" :value="type">{{ type }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>House Geo Location (জিও লোকেশন)</label>
                            <input disabled class="form-control" type="text" placeholder="Type House Geo Location (জিও লোকেশন)" v-model="house.home.house_geo_location" style="height: 44px;">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Distance (দূরত্ব)</label>
                            <input disabled class="form-control" type="text" placeholder="Type House Distance (দূরত্ব)" v-model="house.home.home_distance_from_shelter" style="height: 44px;">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>House to Shelter Road Condition (রাস্তার অবস্থা)</label> 
                            <select disabled class="form-control digits" v-model="house.home.road_condition" style="height: 44px;">
                                <option selected disabled>Select a condition</option>
                                <option v-for="(type, index) in road_conditions" :key="index" :value="type">{{ type }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <!-- <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Image (বাড়ীর ছবি)</label>
                            <div style="display: flex; gap: 12px;">
                                <div v-for="(image, index) in house.home.home_image" :key="index">
                                    <img style="height: 80px; width: 80px; border-radius: 6px;" :src="host + image.image">
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- <div class="title-button"> -->
                    <p style="font-size: larger; font-weight: 600;">Family Representative (প্রধান সদস্য)</p>
                    <!-- <button @click="updateCoreMember(house.user1)" class="btn btn-primary">Update Family Representative</button>
                </div> -->

                <div class="row"> 
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Name (নাম)</label>
                            <input disabled class="form-control" type="text" placeholder="Type Name (নাম)" v-model="house.user1.name" style="height: 44px;">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Phone Number (ফোন নাম্বার)</label>
                            <input disabled class="form-control" type="text" placeholder="Type Phone Number (ফোন নাম্বার)" v-model="house.user1.phone" style="height: 44px;">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>NID (এনআইডি)</label>
                            <input disabled class="form-control" type="text" placeholder="Type NID (এনআইডি)" v-model="house.user1.nid" style="height: 44px;">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Gender (লিঙ্গ)</label>
                            <select disabled class="form-control digits" v-model="house.user1.gender" style="height: 44px;">
                                <option selected disabled>Select a gender</option>
                                <option v-for="(type, index) in genders" :key="index" :value="type.value">{{ type.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Age (বয়স)</label>
                            <select disabled class="form-control digits" v-model="house.user1.age" style="height: 44px;">
                                <option selected disabled>Select a age</option>
                                <option v-for="(type, index) in age" :key="index" :value="type">{{ type }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Health Condition (শারীরিক অবস্থা)</label>
                            <select disabled class="form-control digits" v-model="house.user1.health_condition" style="height: 44px;">
                                <option selected disabled>Select a condition</option>
                                <option v-for="(type, index) in healthCondition " :key="index" :value="type">{{ type }}</option>
                            </select>
                            <!-- <input disabled class="form-control" type="text" v-model="house.user1.health_condition" style="height: 44px; text-transform: capitalize;"> -->
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Total Members (পরিবারের সদস্য সংখ্যা)</label>
                            <select disabled class="form-control digits" v-model="house.user1.total_member" style="height: 44px;">
                                <option selected disabled>Select a number</option>
                                <option v-for="(type, index) in totalMember " :key="index" :value="type">{{ type }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <!-- <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Image (প্রধান সদস্যের ছবি)</label>
                            <div style="display: flex; gap: 12px;">
                                <div v-for="(image, index) in house.user1.core_member_image" :key="index">
                                    <img style="height: 80px; width: 80px; border-radius: 6px;" :src="host + image.image">
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- <div class="title-button"> -->
                    <p style="font-size: larger; font-weight: 600;">Sub Representative (উপ সদস্য)</p>
                    <!-- <button @click="updateCoreMember(house.user2)" class="btn btn-primary">Update Sub Representative</button>
                </div> -->

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Name (নাম)</label>
                            <input disabled class="form-control" type="text" placeholder="Type Name (নাম)" v-model="house.user2.name" style="height: 44px;">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Phone Number (ফোন নাম্বার)</label>
                            <input disabled class="form-control" type="text" placeholder="Type Phone Number (ফোন নাম্বার)" v-model="house.user2.phone" style="height: 44px;">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>NID (এনআইডি)</label>
                            <input disabled class="form-control" type="text" placeholder="Type NID (এনআইডি)" v-model="house.user2.nid" style="height: 44px;">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Gender (লিঙ্গ)</label>
                            <select disabled class="form-control digits" v-model="house.user2.gender" style="height: 44px;">
                                <option selected disabled>Select a gender</option>
                                <option v-for="(type, index) in genders" :key="index" :value="type.value">{{ type.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Age (বয়স)</label>
                            <select disabled class="form-control digits" v-model="house.user2.age" style="height: 44px;">
                                <option selected disabled>Select a age</option>
                                <option v-for="(type, index) in age" :key="index" :value="type">{{ type }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Health Condition (শারীরিক অবস্থা)</label>
                            <select disabled class="form-control digits" v-model="house.user2.health_condition" style="height: 44px;">
                                <option selected disabled>Select a condition</option>
                                <option v-for="(type, index) in healthCondition" :key="index" :value="type">{{ type }}</option>
                            </select>
                            <!-- <input disabled class="form-control" type="text" v-model="house.user2.health_condition" style="height: 44px; text-transform: capitalize;"> -->
                        </div>
                    </div>
                </div>

                <!-- <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Image (উপ সদস্যের ছবি)</label>
                            <div style="display: flex; gap: 12px;">
                                <div v-for="(image, index) in house.user2.core_member_image" :key="index">
                                    <img style="height: 80px; width: 80px; border-radius: 6px;" :src="host + image.image">
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- <div style="display: flex; gap: 8px; justify-content: space-between; align-items: center;">
                    <div></div>
                    <div v-if="selected && selected.length >= 1">
                        <button @click="deleteSelectedOtherMembers" class="btn btn-danger" :disabled="isDisabled">Delete Selected</button>
                    </div>
                </div> -->

                <div v-for="(member, index) in this.house.other_members" :key="index"> 
                    <!-- <div class="title-button"> -->
                        <!-- <div style="display: flex; gap: 8px;"> -->
                            <!-- <span style="margin-top: 6px;"> 
                                <input :id="'checkbox-' + index" :name="'checkbox-' + index" type="checkbox" :value="member.id" v-model="selected">
                            </span> -->
                            <p style="font-size: larger; font-weight: 600;">Member- {{ index + 3 }} Details (মেম্বার- {{ index + 3 }} এর বিবরণ)</p>
                        <!-- </div> -->
                        <!-- <button @click="updateOtherMember(member)" class="btn btn-primary">Update Member- {{ index + 3 }}</button>
                    </div> -->

                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label>Gender (লিঙ্গ)</label>
                                <select disabled class="form-control digits" v-model="member.other_member_gender" style="height: 44px;">
                                    <option selected disabled>Select a gender</option>
                                    <option v-for="(type, index) in genders" :key="index" :value="type.value">{{ type.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label>Age (বয়স)</label>
                                <select disabled class="form-control digits" v-model="member.other_member_age" style="height: 44px;">
                                    <option selected disabled>Select a age</option>
                                    <option v-for="(type, index) in age" :key="index" :value="type">{{ type }}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Health Condition (শারীরিক অবস্থা)</label>
                                <select disabled class="form-control digits" v-model="member.other_member_health_condition" style="height: 44px;">
                                    <option selected disabled>Select a condition</option>
                                    <option v-for="(type, index) in healthCondition" :key="index" :value="type">{{ type }}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Image (মেম্বার- {{ index + 3 }} এর ছবি)</label>
                                <div style="display: flex; gap: 12px;">
                                    <div v-for="(image, index) in member.other_member_image" :key="index">
                                        <img style="height: 80px; width: 80px; border-radius: 6px;" :src="host + image.image">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </b-modal>
    
        <!-- House Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this house?</div>
        </b-modal>
    </div>
</template>
    
<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import { mapState } from 'vuex';
    import { myHost } from '../../../_helpers/host';
    import loader from '../loader/loader.vue';
    import Multiselect from 'vue-multiselect';
    
    export default {
        components: {
            loader,
            Multiselect
        },
    
        data() {
            return {
                host: myHost.host,
                selected: [],
                isDisabled: false,
                house: {
                    home_address: {
                        address_upozila: null,
                        address_union: null,
                        address_shelter: null
                    },
                    home: {
                        road_condition: null,
                        doc_id: null,
                        house_name: null,
                        house_type: null,
                        house_geo_location: null,
                        home_distance_from_shelter: null,
                        address_line: null,
                        home_image: []
                    },
                    user1: {
                        id: null,
                        name: null,
                        nid: null,
                        phone: null,
                        gender: null,
                        age: null,
                        health_condition: null,
                        total_member: null,
                        primary: true,
                        core_member_image: []
                    },
                    user2: {
                        id: null,
                        name: null,
                        nid: null,
                        phone: null,
                        gender: null,
                        age: null,
                        health_condition: null,
                        total_member: null,
                        primary: false,
                        core_member_image: []
                    },
                    other_members: []
                },
                house_types: ["Multi-Stored", "Concrete", "Tin-Shade", "Mud-House"],
                road_conditions: ["Asphalt", "Brick", "Country-Road"],
                genders: [
                    {
                        name: "Male", 
                        value: "male"
                    },
                    {
                        name: "Female", 
                        value: "female"
                    }
                ],
                totalMember: [ "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15"],
                healthCondition: ["Good", "Sick", "Disability", "Pregnant"],
                age: [
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "10",
                    "11",
                    "12",
                    "13",
                    "14",
                    "15",
                    "16",
                    "17",
                    "18",
                    "19",
                    "20",
                    "21",
                    "22",
                    "23",
                    "24",
                    "25",
                    "26",
                    "27",
                    "28",
                    "29",
                    "30",
                    "31",
                    "32",
                    "33",
                    "34",
                    "35",
                    "36",
                    "37",
                    "38",
                    "39",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48",
                    "49",
                    "50",
                    "51",
                    "52",
                    "53",
                    "54",
                    "55",
                    "56",
                    "57",
                    "58",
                    "59",
                    "60",
                    "61",
                    "62",
                    "63",
                    "64",
                    "65",
                    "66",
                    "67",
                    "68",
                    "69",
                    "70",
                    "71",
                    "72",
                    "73",
                    "74",
                    "75",
                    "76",
                    "77",
                    "78",
                    "79",
                    "80",
                    "81",
                    "82",
                    "83",
                    "84",
                    "85",
                    "86",
                    "87",
                    "88",
                    "89",
                    "90"
                ],
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'house',
                        label: 'House',
                        sortable: true
                    },
                    {
                        key: 'address',
                        label: 'Address',
                        sortable: true
                    },
                    {
                        key: 'family_representative',
                        label: 'Family Representative',
                        sortable: true
                    },
                    {
                        key: 'sub_representative',
                        label: 'Sub Representative',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],
   
                assignedShelter: [], 
                show_edit_image: null,
                delete_value: null,
    
                initialLoad: true,
                filterShow: false,
                health_condition: null,
                house_condition: null,
                shelter: null,
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 25,
                pageOptions: [25, 50, 100],
            };
        },
    
        computed: {
            ...mapState({
                house_list: state => state.house.house,
                loading: state => state.house.houseLoading,
                error: state => state.house.houseError,
                shelter_list: state => state.shelter.shelter,
                count: state => state.house.house_count,
                upozilas: state => state.upazila.upazila,
                union: state => state.union.union
            }),
    
            formattedShelters() {
                return [{
                        value: '',
                        text: 'Select a Shelter',
                        disabled: true
                    },
                    ...this.shelter_list.map(shelter => ({
                        value: shelter.id,
                        text: shelter.name
                    }))
                ];
            },
            formattedHealth() {
                return [{
                        value: '',
                        text: 'Select a health condition',
                        disabled: true
                    },
                    ...this.healthCondition.map(condition => ({
                        value: condition,
                        text: condition
                    }))
                ];
            },
            formattedHouse() {
                return [{
                        value: '',
                        text: 'Select a house type',
                        disabled: true
                    },
                    ...this.house_types.map(type => ({
                        value: type,
                        text: type
                    }))
                ];
            },
        },

        watch: {
            filter(newVal, oldVal) {
                if (!this.initialLoad) {
                    this.$store.dispatch("house/fetchHouse", { 
                        perPage: this.perPage,
                        currentPage: 1,
                        shelter: this.shelter,
                        search_term: this.filter,
                        house_condition: this.house_condition,
                        health_condition: this.health_condition,
                    }).then(() => {
                        this.currentPage = 1
                        this.totalRows = this.count;
                        this.initialLoad = false
                    });
                }
            },

            shelter(newVal, oldVal) {
                if (!this.initialLoad) {
                    this.$router.replace({
                        path: '/house/list',
                        query: {
                            page: this.currentPage,
                            perPage: this.perPage,
                            house_condition: this.house_condition,
                            health_condition: this.health_condition,
                            shelter: newVal
                        }
                    });

                    this.$store.dispatch("house/fetchHouse", {
                        perPage: this.perPage,
                        currentPage: 1,
                        shelter: newVal,
                        search_term: this.filter,
                        house_condition: this.house_condition,
                        health_condition: this.health_condition,
                    }).then(() => {
                        this.currentPage = 1
                        this.totalRows = this.count;
                        this.initialLoad = false
                    });
                }
            },
            
            health_condition(newVal, oldVal) {
                if (!this.initialLoad) {
                    // if(this.health_condition != null && this.house_condition == null && this.shelter == null) {
                    //     this.$router.replace({
                    //         path: '/house/list',
                    //         query: {
                    //             page: this.currentPage,
                    //             perPage: this.perPage,
                    //             health_condition: newVal
                    //         }
                    //     });
                    // } else if (this.health_condition != null && this.house_condition != null && this.shelter == !null) {
                    //     this.$router.replace({
                    //         path: '/house/list',
                    //         query: {
                    //             page: this.currentPage,
                    //             perPage: this.perPage,
                    //             house_condition: this.house_condition,
                    //             health_condition: newVal,
                    //             shelter: this.sh
                    //         }
                    //     });
                    // } else if (this.house_condition != null && this.health_condition == null) {
                    //     this.$router.replace({
                    //         path: '/house/list',
                    //         query: {
                    //             page: this.currentPage,
                    //             perPage: this.perPage,
                    //             house_condition: this.house_condition
                    //         }
                    //     });
                    // } else {
                    //     this.$router.replace({
                    //         path: '/house/list'
                    //     });
                    // }

                    this.$router.replace({
                            path: '/house/list',
                            query: {
                                page: this.currentPage,
                                perPage: this.perPage,
                                house_condition: this.house_condition,
                                health_condition: newVal,
                                shelter: this.shelter
                            }
                        });

                    this.$store.dispatch("house/fetchHouse", {
                        perPage: this.perPage,
                        currentPage: 1,
                        shelter: this.shelter,
                        health_condition: newVal,
                        house_condition: this.house_condition,
                        search_term: this.filter
                    }).then(() => {
                        this.currentPage = 1
                        this.totalRows = this.count;
                        this.initialLoad = false
                    });
                }
            },

            house_condition(newVal, oldVal) {
                if (!this.initialLoad) {
                    // if(this.health_condition != null && this.house_condition == null) {
                    //     this.$router.replace({
                    //         path: '/house/list',
                    //         query: {
                    //             page: this.currentPage,
                    //             perPage: this.perPage,
                    //             health_condition: this.health_condition
                    //         }
                    //     });
                    // } else if (this.health_condition != null && this.house_condition != null) {
                    //     this.$router.replace({
                    //         path: '/house/list',
                    //         query: {
                    //             page: this.currentPage,
                    //             perPage: this.perPage,
                    //             house_condition: newVal,
                    //             health_condition: this.health_condition
                    //         }
                    //     });
                    // } else if (this.house_condition != null && this.health_condition == null) {
                    //     this.$router.replace({
                    //         path: '/house/list',
                    //         query: {
                    //             page: this.currentPage,
                    //             perPage: this.perPage,
                    //             house_condition: newVal
                    //         }
                    //     });
                    // } else {
                    //     this.$router.replace({
                    //         path: '/house/list'
                    //     });
                    // }

                    this.$router.replace({
                        path: '/house/list',
                        query: {
                            page: this.currentPage,
                            perPage: this.perPage,
                            house_condition: newVal,
                            health_condition: this.health_condition,
                            shelter: this.shelter
                        }
                    });

                    this.$store.dispatch("house/fetchHouse", {
                        perPage: this.perPage,
                        currentPage: 1,
                        shelter: this.shelter,
                        health_condition: this.health_condition,
                        house_condition: newVal,
                        search_term: this.filter
                    }).then(() => {
                        this.currentPage = 1
                        this.totalRows = this.count;
                        this.initialLoad = false
                    });
                }
            },

            currentPage(newCurrentPage) {
                if (!this.initialLoad) {
                    if(this.health_condition != null && this.house_condition == null) {
                        this.$router.replace({
                            path: '/house/list',
                            query: {
                                page: newCurrentPage,
                                perPage: this.perPage,
                                health_condition: this.health_condition
                            }
                        });
                    } else if (this.health_condition != null && this.house_condition != null) {
                        this.$router.replace({
                            path: '/house/list',
                            query: {
                                page: newCurrentPage,
                                perPage: this.perPage,
                                house_condition: this.house_condition,
                                health_condition: this.health_condition
                            }
                        });
                    } else if (this.house_condition != null && this.health_condition == null) {
                        this.$router.replace({
                            path: '/house/list',
                            query: {
                                page: newCurrentPage,
                                perPage: this.perPage,
                                house_condition: this.house_condition
                            }
                        });
                    } else {
                        this.$router.replace({
                            path: '/house/list',
                            query: {
                                page: newCurrentPage,
                                perPage: this.perPage
                            }
                        });
                    }

                    this.currentPage = newCurrentPage
                    this.$store.dispatch("house/fetchHouse", {
                        perPage: this.perPage,
                        currentPage: newCurrentPage,
                        shelter: this.shelter,
                        search_term: this.filter,
                        house_condition: this.house_condition,
                        health_condition: this.health_condition
                    }).then(() => {
                        this.totalRows = this.count;
                        this.initialLoad = false
                    });
                }
            },

            perPage(newperPage) {
                if (!this.initialLoad) {
                    if(this.health_condition != null && this.house_condition == null) {
                        this.$router.replace({
                            path: '/house/list',
                            query: {
                                page: this.currentPage,
                                perPage: newperPage,
                                health_condition: this.health_condition
                            }
                        });
                    } else if (this.health_condition != null && this.house_condition != null) {
                        this.$router.replace({
                            path: '/house/list',
                            query: {
                                page: this.currentPage,
                                perPage: newperPage,
                                house_condition: this.house_condition,
                                health_condition: this.health_condition
                            }
                        });
                    } else if (this.house_condition != null && this.health_condition == null) {
                        this.$router.replace({
                            path: '/house/list',
                            query: {
                                page: this.currentPage,
                                perPage: newperPage,
                                house_condition: this.house_condition
                            }
                        });
                    } else {
                        this.$router.replace({
                            path: '/house/list',
                            query: {
                                page: this.currentPage,
                                perPage: newperPage
                            }
                        });
                    }
                    
                    this.perPage = newperPage
                    this.$store.dispatch("house/fetchHouse", {
                        perPage: newperPage,
                        currentPage: this.currentPage,
                        shelter: this.shelter,
                        search_term: this.filter,
                        house_condition: this.house_condition,
                        health_condition: this.health_condition
                    }).then(() => {
                        this.totalRows = this.count;
                        this.initialLoad = false
                    });
                }
            }
        },
    
        mounted() {
            this.$store.dispatch("shelter/fetchShelter")
            this.$store.dispatch("union/fetchUnion")
            this.$store.dispatch("upazila/fetchUpazila")

            if (this.initialLoad) {
                if (!this.$route.query.page || !this.$route.query.perPage) {
                    this.$router.replace({
                        path: this.$route.path,
                        query: {
                            page: this.currentPage,
                            perPage: this.perPage
                        }
                    }).catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                            throw err;
                        }
                    });
                    this.fetchInitial();
                } else {
                    this.currentPage = parseInt(this.$route.query.page);
                    this.perPage = parseInt(this.$route.query.perPage);
                    this.fetchInitial();
                }
            }
        },
    
        methods: {
            fetchInitial() {
                this.$store.dispatch("house/fetchHouse", {
                    perPage:  this.$route.query.perPage,
                    currentPage: this.$route.query.page,
                    shelter: this.$route.query.shelter,
                    search_term: this.filter,
                    house_condition: this.$route.query.house_condition,
                    health_condition: this.$route.query.health_condition
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            },

            getDetail(houseDetail) {
                this.house.home_address.address_shelter = houseDetail.home_address.address_shelter
                this.house.home_address.address_union = houseDetail.home_address.address_union
                this.house.home_address.address_upozila = houseDetail.home_address.address_upozila

                this.house.home.house_name = houseDetail.home.house_name
                this.house.home.house_type = houseDetail.home.house_type
                this.house.home.house_geo_location = houseDetail.home.house_geo_location
                this.house.home.home_distance_from_shelter = houseDetail.home.home_distance_from_shelter
                this.house.home.road_condition = houseDetail.home.road_condition
                this.house.home.home_image = houseDetail.home.home_image

                this.house.user1.id = houseDetail.user1.id
                this.house.user1.name = houseDetail.user1.name
                this.house.user1.phone = houseDetail.user1.phone
                this.house.user1.nid = houseDetail.user1.nid
                this.house.user1.gender = houseDetail.user1.gender
                this.house.user1.age = houseDetail.user1.age
                this.house.user1.health_condition = houseDetail.user1.health_condition
                this.house.user1.total_member = houseDetail.user1.total_member
                this.house.user1.core_member_image = houseDetail.user1.core_member_image

                this.house.user2.id = houseDetail.user2.id
                this.house.user2.name = houseDetail.user2.name
                this.house.user2.phone = houseDetail.user2.phone
                this.house.user2.nid = houseDetail.user2.nid
                this.house.user2.gender = houseDetail.user2.gender
                this.house.user2.age = houseDetail.user2.age
                this.house.user2.health_condition = houseDetail.user2.health_condition
                this.house.user2.core_member_image = houseDetail.user2.core_member_image

                this.house.other_members = houseDetail.other_members
            },

            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },

            clearFilter() {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                });
                this.filterShow = false,
                this.filter = null,
                this.fetchInitial();
            },

            toggleFilterShow() {
                this.filterShow = !this.filterShow
                this.shelter = null,
                this.house_condition = null
                this.health_condition = null
            },
    
            deleteShelter(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("house/deleteVolunteer", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.delete_value = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            },

            destroyModalInstance() {
                this.selected = []
                this.isDisabled = false
            },

            deleteSelectedOtherMembers() { 
                this.isDisabled = true; 
                this.$store.dispatch("house/deleteOtherMembers", {
                    ids: this.selected,
                    perPage: this.$route.query.perPage,
                    page: this.$route.query.page,
                    shelter: this.$route.query.shelter,
                    search_term: this.filter,
                    house_condition: this.$route.query.house_condition,
                    health_condition: this.$route.query.health_condition
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.delete_value = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
                this.$bvModal.hide('modal-prevent-closing-edit') 
                this.selected = []
                this.isDisabled = false
            },

            updateOtherMember(member) { 
                this.$store.dispatch("house/editOtherMember", {
                    id: member.id,
                    other_member_age: member.other_member_age,
                    other_member_gender: member.other_member_gender,
                    other_member_health_condition: member.other_member_health_condition,
                    home: member.home,
                    perPage: this.$route.query.perPage,
                    page: this.$route.query.page,
                    shelter: this.$route.query.shelter,
                    search_term: this.filter,
                    house_condition: this.$route.query.house_condition,
                    health_condition: this.$route.query.health_condition
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.delete_value = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
                this.$bvModal.hide('modal-prevent-closing-edit') 
            },

            updateCoreMember(member) { 
                console.log(member)
                this.$store.dispatch("house/editCoreMember", {
                    id: member.id,
                    age: member.age,
                    gender: member.gender,
                    core_health_condition: member.health_condition,
                    perPage: this.$route.query.perPage,
                    page: this.$route.query.page,
                    shelter: this.$route.query.shelter,
                    search_term: this.filter,
                    house_condition: this.$route.query.house_condition,
                    health_condition: this.$route.query.health_condition
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
                // this.$bvModal.hide('modal-prevent-closing-edit') 
            }
        }
    };
</script>
    
<style scoped>
.table-danger {
    background-color: #f8d7da !important;
    color: #721c24 !important;
}

.title-button {
    display: flex; 
    justify-content: space-between; 
    margin-top: 12px;
    gap: 8px; 
    align-items: center;
    margin-bottom: 8px;
}

@media only screen and (max-width: 992px) {
    .title-button {
        display: flex; 
        flex-direction: column;
        justify-content: start; 
        margin-top: 12px;
        gap: 0px; 
        align-items: start;
        margin-bottom: 20px;
    }
}
</style>